import { APPLICATION_REFERRER } from 'Src/consts/constants';

const validateIfUrlIsInStore = (referrer: string) => /instore\/\d{19}/.test(referrer);

interface ReferrerObject {
  isInStore: boolean;
  previousReferrer: string;
  value: string;
}

export const deleteReferrerInStoreFromLocalStorage = () => {
  localStorage.removeItem(APPLICATION_REFERRER);
};

export const getReferrerInStoreFromLocalStorage = () => {
  const referrer = localStorage.getItem(APPLICATION_REFERRER);
  if (referrer) {
    try {
      return JSON.parse(referrer) as ReferrerObject;
    } catch {
      return null;
    }
  }
  return null;
};

export const saveReferrerInStoreInLocalStorage = (url: string) => {
  const { value: previousReferrer = '' } = getReferrerInStoreFromLocalStorage() ?? {};
  const referrer: ReferrerObject = {
    isInStore: validateIfUrlIsInStore(url),
    previousReferrer,
    value: url,
  };

  if (url && url !== previousReferrer) {
    localStorage.setItem(APPLICATION_REFERRER, JSON.stringify(referrer));
  }
};
